"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatusLed = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var styles_1 = __importDefault(require("./styles"));
var StatusLed = function (_a) {
    var color = _a.color, width = _a.width;
    var classes = (0, styles_1.default)({
        color: color,
        width: width,
    });
    return (0, jsx_runtime_1.jsx)("span", { className: classes.led, "data-testid": "led" });
};
exports.StatusLed = StatusLed;
